var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('bg-dialog',{attrs:{"visible":_vm.visible,"title":_vm.title,"alwaysMaxHeight":true},on:{"close":_vm.close}},[(_vm.visible)?_c('iframe',{staticClass:"PdfPreviewer__pageFrame",attrs:{"src":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }